import { render, staticRenderFns } from "./DiscourseView.vue?vue&type=template&id=acfff056&scoped=true"
import script from "./DiscourseView.vue?vue&type=script&lang=ts"
export * from "./DiscourseView.vue?vue&type=script&lang=ts"
import style0 from "./DiscourseView.vue?vue&type=style&index=0&id=acfff056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfff056",
  null
  
)

export default component.exports